import {
  Button,
  ButtonIconPosition,
  ButtonStyles,
  ButtonTypes,
  useSession,
  useTranslation,
} from '@nextgen-web-framework/all';
import { useState } from 'react';
import MultiAccountSelector from '../MultiAccountSelector';
import { SwitchAccountButtonProps } from '../types/propTypes';
import styles from './SwitchAccountButton.module.scss';

const SwitchAccountButton = ({ onCallBack }: SwitchAccountButtonProps) => {
  const t = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [closeIcon, setCloseIcon] = useState(false);
  const { session } = useSession();
  const { accounts = [] } = session;
  const onClickHandler = () => {
    setShowModal(true);
    setCloseIcon(true);
  };

  const multiAccountSelectorProps = {
    accountList: accounts,
    onClose: () => {
      setShowModal(false);
    },
    closeIcon: closeIcon,
    callback: onCallBack,
  };
  return (
    <>
      {showModal && <MultiAccountSelector data-testid="switch-account-modal-testid" {...multiAccountSelectorProps} />}
      {!showModal && (
        <div className={styles['switch-account-button-container']}>
          <Button
            data-testid="switch-account-btn-testid"
            buttonStyle={ButtonStyles.OUTLINE}
            icon={{
              iconName: 'arrows-left-right',
            }}
            iconPosition={ButtonIconPosition.LEFT}
            buttonType={ButtonTypes.BUTTON}
            title={t('identity.SwitchAccountButton.buttonTitle')}
            onClick={onClickHandler}
          />
        </div>
      )}
    </>
  );
};

export default SwitchAccountButton;
